import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const requestTariffGetList = () =>
    axios.get(`${apiUrl}tariff/list`);

export const requestTariffAdd = (data) =>
    axios.post(`${apiUrl}tariff`, data);

export const requestTariffGetTypes = () =>
    axios.get(`${apiUrl}tariff/types`);



// WEBPACK FOOTER //
// ./src/actions/tariff/requests.js